<svg
  xmlns="http://www.w3.org/2000/svg"
  [ngClass]="{
    tablet: globalUtilsService.isTablet(),
    mobile: globalUtilsService.isMobile()
  }"
  viewBox="0 0 198.162 55"
>
  <g transform="translate(-135.231 -174.309)">
    <path
      d="M183.5,181.059a16.971,16.971,0,0,0-13.612-6.75H157.33a3.083,3.083,0,0,0-3.006,2.369l-1.9,7.918h-2.2a8.533,8.533,0,0,0-8.421,7.079l-6.567,37.635H145.4a8.535,8.535,0,0,0,6.509-3.007l6.623-7.78a4.178,4.178,0,0,1,3.185-1.471h.337a24.368,24.368,0,0,0,23.414-17.805l.906-3.265A16.971,16.971,0,0,0,183.5,181.059Zm.414,14.241-.905,3.266A21.814,21.814,0,0,1,162.05,214.5h-.337a6.72,6.72,0,0,0-5.124,2.367l-6.623,7.78a5.993,5.993,0,0,1-4.57,2.111H138.26l6.046-34.651a5.991,5.991,0,0,1,5.912-4.97h1.59l-2.308,9.6h6.077l-6.067,20.27L176.673,184.6H157.949l-.612,2.546h13.881L155.49,205.91,159,194.195h-6.266l4.068-16.921a.545.545,0,0,1,.531-.418h12.559A14.556,14.556,0,0,1,183.915,195.3Z"
      fill="#2acc16"
    />
    <g transform="translate(199.08 184.161)">
      <g transform="translate(0 0)">
        <path
          d="M379.25,210.762a7.955,7.955,0,0,1,3.142,6.06,10.1,10.1,0,0,1-1.144,5.8,9.08,9.08,0,0,1-4.179,3.794,15.588,15.588,0,0,1-6.719,1.322h-5.89L363.484,235H357.4l3.2-25.142a1.437,1.437,0,0,1,1.45-1.264h9.4A12.617,12.617,0,0,1,379.25,210.762Zm-4.381,10.59a4.609,4.609,0,0,0,1.369-4,3.584,3.584,0,0,0-1.471-2.832,6.346,6.346,0,0,0-3.712-.944h-4.8l-1.181,9.175h5.173A6.721,6.721,0,0,0,374.869,221.353Z"
          transform="translate(-357.403 -208.591)"
          fill="#fff"
        />
      </g>
      <g transform="translate(91.947 5.815)">
        <path
          d="M681.14,249.156a11.73,11.73,0,0,1-3.793-1.529l1.954-4.267a12.3,12.3,0,0,0,3.33,1.4,14.7,14.7,0,0,0,3.871.528,6.476,6.476,0,0,0,2.946-.51,1.453,1.453,0,0,0,.876-1.454,1.265,1.265,0,0,0-.948-1.095,18.817,18.817,0,0,0-2.846-.717,27.456,27.456,0,0,1-3.672-.906,6.6,6.6,0,0,1-2.571-1.6,4.589,4.589,0,0,1-1.26-3.039,5.525,5.525,0,0,1,2.43-5.248,12.352,12.352,0,0,1,7.244-1.888,19.028,19.028,0,0,1,4.148.453,13.359,13.359,0,0,1,3.489,1.246l-1.8,4.3a11.75,11.75,0,0,0-6.116-1.548,5.8,5.8,0,0,0-2.885.567,1.512,1.512,0,0,0-.9,1.435,1.322,1.322,0,0,0,.952,1.152,18.683,18.683,0,0,0,2.964.774,28.467,28.467,0,0,1,3.595.887,6.408,6.408,0,0,1,2.512,1.567,4.511,4.511,0,0,1,1.237,2.983,5.45,5.45,0,0,1-2.468,5.248,12.665,12.665,0,0,1-7.247,1.85A21.237,21.237,0,0,1,681.14,249.156Z"
          transform="translate(-677.347 -228.824)"
          fill="#fff"
        />
      </g>
      <g transform="translate(111.935 5.815)">
        <path
          d="M752.368,248.609a9.374,9.374,0,0,1-3.82-3.191,9.473,9.473,0,0,1-1.613-4.776,11.114,11.114,0,0,1,1.145-6.041,10.257,10.257,0,0,1,4.072-4.229,12.16,12.16,0,0,1,6.193-1.548,12.635,12.635,0,0,1,5.481,1.133,9.261,9.261,0,0,1,5.414,7.967,11.223,11.223,0,0,1-1.127,6.041,10.1,10.1,0,0,1-4.071,4.229,12.257,12.257,0,0,1-6.211,1.548A12.674,12.674,0,0,1,752.368,248.609Zm8.482-4.587a5.173,5.173,0,0,0,1.942-2.36,7.381,7.381,0,0,0,.5-3.474,4.777,4.777,0,0,0-1.448-3.285,4.91,4.91,0,0,0-3.486-1.208,5.416,5.416,0,0,0-3.035.85,5.174,5.174,0,0,0-1.942,2.36,7.375,7.375,0,0,0-.5,3.474,4.732,4.732,0,0,0,1.467,3.284,4.974,4.974,0,0,0,3.505,1.208A5.346,5.346,0,0,0,760.85,244.021Z"
          transform="translate(-746.899 -228.824)"
          fill="#fff"
        />
      </g>
      <g transform="translate(48.023 5.815)">
        <path
          d="M539.1,228.824l-.66,5.437q-1.063-.075-1.365-.076a6.144,6.144,0,0,0-4.189,1.322,6.336,6.336,0,0,0-1.871,4.115l-1.247,9.817h-5.261l1.515-12.028a9.734,9.734,0,0,1,9.415-8.514C537.131,228.855,538.561,228.824,539.1,228.824Z"
          transform="translate(-524.508 -228.824)"
          fill="#fff"
        />
      </g>
      <g transform="translate(84.342 6.059)">
        <path
          d="M653.414,229.675h5.537l-2.529,20.371h-5.538Z"
          transform="translate(-650.885 -229.675)"
          fill="#fff"
        />
      </g>
      <g transform="translate(25.998 5.815)">
        <path
          d="M470.258,229.126h-5.044l-.315,2.5q-2.16-2.8-6.641-2.806a10.285,10.285,0,0,0-5.552,1.529,9.912,9.912,0,0,0-3.751,4.229,11.8,11.8,0,0,0-1.049,6.06,10.078,10.078,0,0,0,1.543,4.852,9.085,9.085,0,0,0,3.42,3.153,9.434,9.434,0,0,0,4.46,1.095,8.448,8.448,0,0,0,5.514-1.792l-.188,1.49H467.7Zm-8.834,14.9a4.959,4.959,0,0,1-2.884.85,4.589,4.589,0,0,1-3.332-1.208,4.846,4.846,0,0,1-1.394-3.284,7.728,7.728,0,0,1,.477-3.474,5.124,5.124,0,0,1,1.846-2.36,4.958,4.958,0,0,1,2.884-.85,4.591,4.591,0,0,1,3.332,1.208,4.849,4.849,0,0,1,1.394,3.285,7.728,7.728,0,0,1-.477,3.474A5.121,5.121,0,0,1,461.424,244.021Z"
          transform="translate(-447.867 -228.824)"
          fill="#fff"
        />
      </g>
      <g transform="translate(62.23 5.815)">
        <path
          d="M596.334,229.126H591.29l-.315,2.5q-2.16-2.8-6.641-2.806a10.286,10.286,0,0,0-5.552,1.529,9.911,9.911,0,0,0-3.75,4.229,11.789,11.789,0,0,0-1.049,6.06,10.082,10.082,0,0,0,1.543,4.852,9.086,9.086,0,0,0,3.421,3.153,9.434,9.434,0,0,0,4.46,1.095,8.448,8.448,0,0,0,5.514-1.792l-.188,1.49h5.043Zm-8.834,14.9a4.96,4.96,0,0,1-2.884.85,4.588,4.588,0,0,1-3.332-1.208,4.845,4.845,0,0,1-1.394-3.284,7.725,7.725,0,0,1,.477-3.474,5.125,5.125,0,0,1,1.846-2.36,4.959,4.959,0,0,1,2.884-.85,4.592,4.592,0,0,1,3.332,1.208,4.85,4.85,0,0,1,1.394,3.285,7.73,7.73,0,0,1-.477,3.474A5.124,5.124,0,0,1,587.5,244.021Z"
          transform="translate(-573.943 -228.824)"
          fill="#fff"
        />
      </g>
      <g transform="translate(88.09 0)">
        <path
          d="M667.632,208.591l-3.7,4.2H667.3a3.637,3.637,0,0,0,2.417-.919l3.689-3.281Z"
          transform="translate(-663.928 -208.591)"
          fill="#fff"
        />
      </g>
    </g>
    <g transform="translate(196.636 221.182)" opacity="0.6">
      <g transform="translate(0 0.109)">
        <path
          d="M351.113,338.976l-.293,2.318h3.689l-.149,1.2h-3.677l-.368,2.916H348.9l.948-7.617h5.56l-.15,1.186Z"
          transform="translate(-348.9 -337.79)"
          fill="#fff"
        />
      </g>
      <g transform="translate(10.993 0)">
        <path
          d="M389.073,344.838a3.278,3.278,0,0,1-1.343-1.142,3.475,3.475,0,0,1-.564-1.7,4.493,4.493,0,0,1,.406-2.329,3.794,3.794,0,0,1,1.524-1.648,4.61,4.61,0,0,1,2.392-.6,4.547,4.547,0,0,1,1.984.408,3.281,3.281,0,0,1,1.343,1.142,3.482,3.482,0,0,1,.564,1.7,4.494,4.494,0,0,1-.406,2.328,3.793,3.793,0,0,1-1.524,1.648,4.605,4.605,0,0,1-2.392.6A4.543,4.543,0,0,1,389.073,344.838Zm3.614-1.273a2.672,2.672,0,0,0,1.01-1.186,3.338,3.338,0,0,0,.263-1.627,2.15,2.15,0,0,0-.73-1.529,2.618,2.618,0,0,0-1.779-.571,2.885,2.885,0,0,0-1.6.441,2.639,2.639,0,0,0-1,1.186,3.374,3.374,0,0,0-.258,1.627,2.157,2.157,0,0,0,.725,1.528,2.6,2.6,0,0,0,1.773.572A2.882,2.882,0,0,0,392.687,343.565Z"
          transform="translate(-387.15 -337.412)"
          fill="#fff"
        />
      </g>
      <g transform="translate(24.069 0.109)">
        <path
          d="M435.178,338.987h-2.525l.149-1.2h6.464l-.16,1.2h-2.524l-.788,6.42h-1.414Z"
          transform="translate(-432.653 -337.79)"
          fill="#fff"
        />
      </g>
      <g transform="translate(34.917 0)">
        <path
          d="M472.323,344.838a3.279,3.279,0,0,1-1.343-1.142,3.482,3.482,0,0,1-.564-1.7,4.492,4.492,0,0,1,.406-2.329,3.8,3.8,0,0,1,1.524-1.648,4.609,4.609,0,0,1,2.392-.6,4.548,4.548,0,0,1,1.984.408,3.283,3.283,0,0,1,1.343,1.142,3.483,3.483,0,0,1,.563,1.7,4.49,4.49,0,0,1-.406,2.328,3.794,3.794,0,0,1-1.524,1.648,4.607,4.607,0,0,1-2.392.6A4.543,4.543,0,0,1,472.323,344.838Zm3.614-1.273a2.669,2.669,0,0,0,1.009-1.186,3.334,3.334,0,0,0,.263-1.627,2.152,2.152,0,0,0-.73-1.529,2.617,2.617,0,0,0-1.778-.571,2.886,2.886,0,0,0-1.6.441,2.639,2.639,0,0,0-1,1.186,3.374,3.374,0,0,0-.258,1.627,2.156,2.156,0,0,0,.725,1.528,2.6,2.6,0,0,0,1.773.572A2.882,2.882,0,0,0,475.937,343.565Z"
          transform="translate(-470.4 -337.412)"
          fill="#fff"
        />
      </g>
      <g transform="translate(48.019 0.109)">
        <path
          d="M524.021,337.79l-4.267,7.617h-1.393l-2.371-7.617h1.458l1.8,5.854,3.3-5.854Z"
          transform="translate(-515.991 -337.79)"
          fill="#fff"
        />
      </g>
      <g transform="translate(60.046 0)">
        <path
          d="M559.762,344.838a3.28,3.28,0,0,1-1.343-1.142,3.485,3.485,0,0,1-.564-1.7,4.492,4.492,0,0,1,.406-2.329,3.793,3.793,0,0,1,1.524-1.648,4.609,4.609,0,0,1,2.392-.6,4.549,4.549,0,0,1,1.984.408,3.284,3.284,0,0,1,1.343,1.142,3.485,3.485,0,0,1,.564,1.7,4.5,4.5,0,0,1-.406,2.328,3.8,3.8,0,0,1-1.524,1.648,4.607,4.607,0,0,1-2.392.6A4.543,4.543,0,0,1,559.762,344.838Zm3.614-1.273a2.67,2.67,0,0,0,1.009-1.186,3.335,3.335,0,0,0,.263-1.627,2.152,2.152,0,0,0-.73-1.529,2.616,2.616,0,0,0-1.778-.571,2.884,2.884,0,0,0-1.6.441,2.639,2.639,0,0,0-1,1.186,3.374,3.374,0,0,0-.258,1.627,2.156,2.156,0,0,0,.725,1.528,2.6,2.6,0,0,0,1.773.572A2.884,2.884,0,0,0,563.377,343.565Z"
          transform="translate(-557.839 -337.412)"
          fill="#fff"
        />
      </g>
      <g transform="translate(73.585 0.109)">
        <path
          d="M605.9,337.79h1.415l-.8,6.42H610.5l-.149,1.2h-5.4Z"
          transform="translate(-604.95 -337.79)"
          fill="#fff"
        />
      </g>
      <g transform="translate(83.355 0.109)">
        <path
          d="M641.472,338.987h-2.524l.149-1.2h6.464l-.16,1.2h-2.524l-.788,6.42h-1.414Z"
          transform="translate(-638.948 -337.79)"
          fill="#fff"
        />
      </g>
      <g transform="translate(92.516 0.109)">
        <path
          d="M677.133,343.644H673.3l-.965,1.763h-1.513l4.375-7.617h1.4l2.468,7.617h-1.4Zm-.345-1.11-1.026-3.351-1.847,3.351Z"
          transform="translate(-670.824 -337.79)"
          fill="#fff"
        />
      </g>
      <g transform="translate(106.022 0.109)">
        <path
          d="M718.77,337.79h1.414l-.948,7.617h-1.414Z"
          transform="translate(-717.822 -337.79)"
          fill="#fff"
        />
      </g>
      <g transform="translate(113.645 0)">
        <path
          d="M746.3,344.838a3.327,3.327,0,0,1-1.365-1.148,3.418,3.418,0,0,1-.575-1.7,4.46,4.46,0,0,1,.412-2.329,3.831,3.831,0,0,1,1.529-1.648,4.631,4.631,0,0,1,2.4-.6,4.557,4.557,0,0,1,1.771.326,2.747,2.747,0,0,1,1.219.947l-.958.86a2.449,2.449,0,0,0-2.037-.892,2.984,2.984,0,0,0-1.632.435,2.666,2.666,0,0,0-1.021,1.181,3.319,3.319,0,0,0-.268,1.638,2.136,2.136,0,0,0,.736,1.534,3.036,3.036,0,0,0,3.9-.316l.894.892a3.011,3.011,0,0,1-1.269.925,4.7,4.7,0,0,1-1.74.3A4.641,4.641,0,0,1,746.3,344.838Z"
          transform="translate(-744.349 -337.412)"
          fill="#fff"
        />
      </g>
      <g transform="translate(125.773 0)">
        <path
          d="M788.472,344.838a3.279,3.279,0,0,1-1.343-1.142,3.477,3.477,0,0,1-.564-1.7,4.493,4.493,0,0,1,.406-2.329,3.793,3.793,0,0,1,1.524-1.648,4.609,4.609,0,0,1,2.392-.6,4.547,4.547,0,0,1,1.984.408,3.278,3.278,0,0,1,1.343,1.142,3.48,3.48,0,0,1,.564,1.7,4.5,4.5,0,0,1-.406,2.328,3.793,3.793,0,0,1-1.524,1.648,4.608,4.608,0,0,1-2.392.6A4.543,4.543,0,0,1,788.472,344.838Zm3.614-1.273a2.672,2.672,0,0,0,1.009-1.186,3.333,3.333,0,0,0,.263-1.627,2.149,2.149,0,0,0-.73-1.529,2.617,2.617,0,0,0-1.779-.571,2.886,2.886,0,0,0-1.6.441,2.64,2.64,0,0,0-1,1.186,3.376,3.376,0,0,0-.258,1.627,2.157,2.157,0,0,0,.725,1.528,2.6,2.6,0,0,0,1.773.572A2.884,2.884,0,0,0,792.086,343.565Z"
          transform="translate(-786.549 -337.412)"
          fill="#fff"
        />
      </g>
    </g>
  </g>
</svg>
